var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Query, CondTag, LinkType } from '@easyquery/core';
import { ConditionEx } from './condition_ex';
import { QueryColumnEx } from './query_column_ex';
import { lcv } from '../utils/lcv';
var QueryEx = /** @class */ (function (_super) {
    __extends(QueryEx, _super);
    function QueryEx(model) {
        return _super.call(this, model) || this;
    }
    QueryEx.prototype.isEx = function () {
        return lcv.__kt > 1;
    };
    QueryEx.prototype.createSubQuery = function () {
        return new QueryEx(this.model);
    };
    QueryEx.prototype.createCondition = function (tag) {
        if (tag === void 0) { tag = CondTag.Simple; }
        if (lcv.__kt <= 1)
            return _super.prototype.createCondition.call(this, tag);
        return new ConditionEx(this, tag);
    };
    QueryEx.prototype.createColumn = function (justsorted) {
        if (justsorted === void 0) { justsorted = false; }
        if (lcv.__kt <= 1)
            return _super.prototype.createColumn.call(this, justsorted);
        return new QueryColumnEx(this, justsorted);
    };
    /**
     * Adds a condition group - a group of simple conditions (predicates) linked by AND or OR
     * @param descriptor The descriptor of the new condition group.
     * @returns The new search condition.
     */
    QueryEx.prototype.addConditionGroup = function (descriptor, addChildCondition) {
        if (addChildCondition === void 0) { addChildCondition = true; }
        if (lcv.__kt <= 1)
            return _super.prototype.addConditionGroup.call(this, descriptor, addChildCondition);
        var parent = descriptor.parent || this.getRootCondition();
        var lType = descriptor.linking || (parent.linkType === LinkType.All ? LinkType.Any : LinkType.All);
        var group = this.createCondition(CondTag.Group);
        group.linkType = lType;
        if (addChildCondition) {
            var model = this.getModel();
            var attr = model.getFirstUICAttr();
            var op = model.getDefaultOperatorForAttr(attr);
            var cond = this.createSimpleConditionObject(attr, op, "");
            group.addCondition(cond);
        }
        parent.addCondition(group);
        return group;
    };
    QueryEx.prototype.addExtraConditionGroup = function (descriptor, addChildCondition) {
        if (addChildCondition === void 0) { addChildCondition = true; }
        descriptor.parent = descriptor.parent || this.extraConditions;
        if (lcv.__kt <= 1)
            return _super.prototype.addExtraConditionGroup.call(this, descriptor, addChildCondition);
        return this.addConditionGroup(descriptor);
    };
    return QueryEx;
}(Query));
export { QueryEx };
//# sourceMappingURL=query_ex.js.map